/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const PRESIDENT_ADVISOR_BACKGROUND =
  "https://media.werz.at/community-assets/PRESIDENTADV/mobile-landing-background.png"

const PRESIDENT_ADVISOR_LOGO =
  "https://media.werz.at/community/icon/cmggwudft00009kn5u85nj2ix.png?uploadTime=1760544535828&type=image&v=1762238616236"

const prezidentAdvisor: CommunityData = {
  code: "prezidentadv",
  inviteCode: "prezidentadv",
  name: "Prezident",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/pra-742`,
  socials: {},
  styles: {
    global: {
      mobileOnly: true,
      counterColor: "#EF4538",
      logo: {
        src: PRESIDENT_ADVISOR_LOGO,
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: PRESIDENT_ADVISOR_LOGO,
        styles: "w-[96px] h-[96px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "border-r border-[#444444]",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: "",
      bgMobile: PRESIDENT_ADVISOR_BACKGROUND,
      nonMemberBg: PRESIDENT_ADVISOR_BACKGROUND,
      mainFont: "font-['Terminal2MonoRegular']",
      primaryButton:
        "bg-[#000000] border border-[#EF4538] px-[16px] py-[16px] text-[#ffffff] font-['Terminal2MonoRegular'] text-[14px] uppercase text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r border-[#444444]",
      separator: "border-[#444444]",
      item: "text-[#ffffff] font-['Terminal2MonoRegular'] text-[14px] uppercase text-left leading-[100%] text-opacity-50 border-b border-[#444444] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] border border-[#444444] !pb-8",
      titles:
        "text-[#EF4538] font-['Terminal2MonoRegular'] text-[24px] uppercase text-left leading-[120%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ffffff] font-['SupplyLight'] text-[14px] text-left leading-[120%]",
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#EF4538] font-['Terminal2MonoRegular'] text-[20px] uppercase text-left leading-[120%]",
        text: "text-[#ffffff] font-['SupplyLight'] text-[14px] text-left leading-[120%]",
        customShopImageStyle: "border border-[#444444]",
        sectionTitle:
          "text-[#EF4538] font-['Terminal2MonoRegular'] text-[24px] uppercase text-left leading-[120%] !mb-4 sm:mb-6",
      },
    },
    linktree: {
      bgDesktop: "",
      bgMobile: "https://media.werz.at/community-assets/PRESIDENTADV/mobile-landing-background.png",
      bgColor: "#000000",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#000000]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#EF4538]",
        name: "text-[#ef4538] font-['Terminal2MonoRegular'] text-[24px] uppercase leading-[120%] text-center text-center mt-4 mb-1",
        location:
          "text-[#ffffff] font-['Terminal2MonoRegular'] text-[14px] uppercase leading-[120%] text-center text-center mb-2",
        description:
          "text-[#ffffff] font-['SupplyLight'] text-[14px] leading-[120%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#ffffff",
        button:
          "bg-[#000000] border border-[#EF4538] px-[16px] py-[16px] text-[#ffffff] font-['Terminal2MonoRegular'] text-[14px] uppercase text-left leading-[100%] w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#444444] text-[#ffffff] font-['SupplyLight'] text-[14px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#000000] border border-[#444444]",
          title:
            "text-[#ffffff] font-['Terminal2MonoRegular'] text-[14px] uppercase leading-[120%] text-left text-center mb-1",
          text: "text-[#ffffff] font-['SupplyLight'] text-[14px] leading-[120%] text-center text-center",
          button:
            "bg-[#000000] border border-[#EF4538] px-[16px] py-[16px] text-[#ffffff] font-['Terminal2MonoRegular'] text-[14px] uppercase text-left leading-[100%] w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ef4538] font-['Terminal2MonoRegular'] text-[14px] uppercase leading-[120%] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#444444]",
          duration: "text-[#bdbdbd] font-['SupplyLight'] text-[12px] leading-[120%] text-left",
          name: "text-[#ffffff] font-['Terminal2MonoRegular'] text-[14px] uppercase leading-[120%] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#ffffff",
          media: "overflow-hidden m-2 border border-[#444444]",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#000000] border border-[#444444]",
          name: "text-[#ffffff] font-['Terminal2MonoRegular'] text-[14px] uppercase leading-[120%] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#EF4538] border border-[#EF4538] text-[#000000] font-['Terminal2MonoRegular'] text-[14px] uppercase leading-[120%] text-center",
          duration: "text-[#bdbdbd] font-['SupplyLight'] text-[12px] leading-[120%] text-left",
          location: "text-[#bdbdbd] font-['SupplyLight'] text-[12px] leading-[120%] text-left",
          button:
            "bg-[#000000] border border-[#EF4538] px-[16px] py-[16px] text-[#ffffff] font-['Terminal2MonoRegular'] text-[14px] uppercase text-left leading-[100%] w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#444444]",
            name: "text-[#ffffff] font-['Terminal2MonoRegular'] text-[14px] uppercase leading-[120%] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#bdbdbd] font-['Terminal2MonoRegular'] text-[14px] uppercase leading-[120%] text-left",
            link: "text-[#bdbdbd] font-['SupplyLight'] text-[12px] leading-[120%] text-left",
            status:
              "text-[#bdbdbd] font-['Terminal2MonoRegular'] text-[14px] uppercase leading-[120%] text-left",
            button:
              "bg-[#000000] border border-[#EF4538] px-[16px] py-[16px] text-[#ffffff] font-['Terminal2MonoRegular'] text-[14px] uppercase text-left leading-[100%] w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#ffffff] font-['SupplyLight'] text-[14px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#444444] text-[#ffffff] font-['SupplyLight'] text-[14px] leading-[120%] text-center",
        header:
          "text-[#ef4538] font-['Terminal2MonoRegular'] text-[14px] uppercase leading-[120%] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#444444]",
          name: "text-[#ffffff] font-['Terminal2MonoRegular'] text-[14px] uppercase leading-[120%] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#ffffff",
          created: "text-[#bdbdbd] font-['SupplyLight'] text-[12px] leading-[120%] text-left",
          media: "overflow-hidden m-2 border border-[#444444]",
        },
        seeAllNews:
          "text-[#ffffff] font-['SupplyLight'] text-[14px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#444444] text-[#ffffff] font-['SupplyLight'] text-[14px] leading-[120%] text-center",
        header:
          "text-[#ef4538] font-['Terminal2MonoRegular'] text-[14px] uppercase leading-[120%] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#444444]",
          coverUrl: "overflow-hidden m-2 border border-[#444444]",
          duration: "text-[#bdbdbd] font-['SupplyLight'] text-[12px] leading-[120%] text-left",
          liveType: "text-[#bdbdbd] font-['SupplyLight'] text-[12px] leading-[120%] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#EF4538] rounded-full",
          playIconColor: "#000000",
          playIconBackgroundColor: "#EF4538",
          playIconBorderColor: "#000000",
          start: "text-[#bdbdbd] font-['SupplyLight'] text-[12px] leading-[120%] text-left",
          title:
            "text-[#ffffff] font-['Terminal2MonoRegular'] text-[14px] uppercase leading-[120%] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#ffffff] font-['SupplyLight'] text-[14px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#444444] text-[#ffffff] font-['SupplyLight'] text-[14px] leading-[120%] text-center",
        header:
          "text-[#ef4538] font-['Terminal2MonoRegular'] text-[14px] uppercase leading-[120%] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#444444]",
          name: "text-[#ffffff] font-['Terminal2MonoRegular'] text-[14px] uppercase leading-[120%] text-left",
          triangleIconColor: "#ffffff",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#444444]",
        },
      },
      footer: {
        WERZlogoColor: "#ffffff",
        text: "text-[#bdbdbd] font-['SupplyLight'] text-[12px] leading-[120%] text-left",
      },
    },
  },
}

export default prezidentAdvisor
